'use strict';

angular.module('app')
  .controller('MainCtrl', function ($scope, $rootScope, gettextCatalog, $anchorScroll, $templateCache,
    $location, $filter, $timeout, $window, Request, utils,
    localStorageService, diviacLocalStorage, HomePage, Auth, mainInfo,
    info, Account, GTM, DiveOperator, cartService, DestinationModel, megaMenu,
    urlMaker, selectedLanguage) {
    var vm = this;

    vm.goTo = utils.goTo;
    vm.isDev = utils.isDev;
    vm.autoSuggest = autoSuggest;
    vm.autoSuggestHome = autoSuggestHome;
    vm.reviewAutoSuggest = reviewAutoSuggest;
    vm.updateData = updateData;
    vm.startSearch = startSearch;
    vm.newSearch = utils.newSearch;
    vm.subscribe = Account.subscribe;
    vm.contactUs = contactUs;
    vm.gtmTrack = GTM.clickTrack;
    vm.plus = plus;
    vm.toggleAll = toggleAll;
    vm.searchOnMobile = searchOnMobile;
    vm.minus = minus;
    vm.fileUpload = fileUpload;
    vm.submitReview = submitReview;
    vm.sendEnquiry = sendEnquiry;
    vm.menu = megaMenu;
    vm.ORDER_REFERAL_KIND = info.checkout.ORDER_REFERAL_KIND;
    vm.destinationUtils = DestinationModel.utils;
    vm.popupFBlogin = popupFBlogin;
    vm.notificationBar = info.notificationBar;
    vm.closeTopMessage = closeTopMessage;
    vm.closeLangWarning = closeLangWarning;
    vm.searchPageUrl = urlMaker.searchPageUrl;
    vm.showInclusions = showInclusions;
    vm.smartSearch = smartSearch;
    vm.ab = {
      registrationPopup: 2, // utils.randomRange(1,3)
    };
    vm.langCode = selectedLanguage === 'ach' || selectedLanguage === 'en'  ? 'en-US' : selectedLanguage + '-' + selectedLanguage.toLocaleUpperCase();
    vm.hideModal = sessionStorage.getItem('hideModal');
    // vm.hideLangWarning = sessionStorage.getItem('hideLangWarning');
    vm.hideLoader = utils.hideLoader;

    // _.each(AVAILABLE_LANGS, function (lang) {
    //     if (document.referrer.search('/' + lang + '/') !== -1) {
    //         reffererPageLang = lang;
    //     }
    // });

    // if (reffererPageLang &&
    //     warningText[reffererPageLang] &&
    //     !vm.hideLangWarning &&
    //     window.location.pathname.search('/' + reffererPageLang  + '/') === -1) {
    //     vm.languageWarning = warningText[reffererPageLang];
    // }

    vm.time = utils.genereateMonthPicker();

    var dateFrom = $location.search().date_from,
      duration = $location.search().duration,
      numberOfDivers = $location.search().number_of_divers ? +$location.search().number_of_divers : null,
      numberOfNonDivers = $location.search().number_of_non_divers ? +$location.search().number_of_non_divers : null,
      rooms = $location.search().number_of_rooms ? +$location.search().number_of_rooms : null;

    if (dateFrom) {
      diviacLocalStorage.set('departure_date_custom', dateFrom);
      diviacLocalStorage.set('date', [dateFrom, moment(dateFrom).add(30, 'd').format('YYYY-MM-DD')]);
    }

    if (duration) {
      diviacLocalStorage.set('duration', duration);
    }

    if ((numberOfDivers || numberOfNonDivers) && rooms) {
      var selectedRoom = {
        id: 'auto',
        divers: numberOfDivers,
        nonDivers: numberOfNonDivers,
        rooms: rooms,
        details: [],
      };


      function placeGuestsInRooms(numberOfDivers, numberOfNonDivers, rooms) {
        if (rooms === 0) {
          return;
        }

        var obj = {
          divers: 0,
          nonDivers: 0,
        };

        if (numberOfDivers + numberOfNonDivers > rooms) {
          if (numberOfDivers) {
            obj.divers = Math.round(numberOfDivers / rooms);

            numberOfDivers -= obj.divers;
          }

          if (numberOfNonDivers) {
            obj.nonDivers = Math.round(numberOfNonDivers / rooms);

            numberOfNonDivers -= obj.nonDivers;
          }

          selectedRoom.details.push(obj);
          rooms -= 1;

          return placeGuestsInRooms(numberOfDivers, numberOfNonDivers, rooms);
        } else if (rooms <= numberOfDivers + numberOfNonDivers) {
          if (numberOfDivers) {
            obj.divers = Math.round(numberOfDivers / rooms);

            numberOfDivers -= obj.divers;
            selectedRoom.details.push(obj);

            rooms -= 1;
            return placeGuestsInRooms(numberOfDivers, numberOfNonDivers, rooms);
          }

          if (numberOfNonDivers) {
            obj.nonDivers = Math.round(numberOfNonDivers / rooms);

            numberOfNonDivers -= obj.nonDivers;

            selectedRoom.details.push(obj);

            rooms -= 1;
            return placeGuestsInRooms(numberOfDivers, numberOfNonDivers, rooms);
          }
        }
      }

      placeGuestsInRooms(numberOfDivers, numberOfNonDivers, rooms);

      diviacLocalStorage.set('roomParams', selectedRoom);
    }


    vm.searchParams = {
      departure_date: diviacLocalStorage.get('departure_date') ? diviacLocalStorage.get('departure_date').id : null,
      departure_date_custom: diviacLocalStorage.get('departure_date_custom') || null,
    };


    if ($location.search().promo_code) {
      diviacLocalStorage.set('promo_code', $location.search().promo_code);
      $location.search({ 'promo_code': null });
    }

    function closeLangWarning() {
      sessionStorage.setItem('hideLangWarning', 'true');
      vm.hideLangWarning = true;
    }

    function closeTopMessage() {
      sessionStorage.setItem('hideModal', 'true');
      vm.hideModal = true;
    }


    var promotionDateStart = '2017-04-23',
      promotionDateEnd = '2017-11-25';

    // vm.flashSale = utils.isDateInRange(promotionDateStart, promotionDateEnd);


    $scope.setReviewValue = setReviewValue;
    $scope.clearReview = clearReview;
    $scope.saveDate = saveDate;

    $rootScope.setValue = setValue;
    init();

    if (selectedLanguage === 'ach') {
      var script = document.createElement('script');
      script.src = 'https://cdn.crowdin.com/jipt/jipt.js';
      document.getElementsByTagName('head')[0].appendChild(script);
    }

    // var ssrPage = [
    //     '/liveaboard-diving/:location/',
    //     '/liveaboard-diving/',
    //     '/d/:location/',
    //     '/group-bookings/',
    //     '/destinations/',
    //     '/dive-resort/:location/:slug/',
    //     '/liveaboard/:location/:slug/',
    //     '/s/dive-resorts/:slug/',
    //     '/faq/',
    //     '/why-book-with-us/',
    //     '/best-price-guarantee/',
    //     '/terms/',
    //     '/'
    // ];

    var ssrPage = [
        'homepage',
        'la_page',
        'dr_page',
        'destination',
        'group_bookings',
        'destinations',
        'liveaboard_diving_location',
        'why_book_with_us',
        'faq',
        'terms',
        'terms_dc',
        'imprint',
        'privacy',
        'best_price_guarantee',
        'liveaboard_diving',
        'search_la',
        'search_dr',
        'fleets',
        'last_minute_deals'
      ],
      ssrPagesWithLangPrefix = [];

    _.each(ssrPage, function (val) {
      ssrPagesWithLangPrefix.push(window.createUrl(val));
    });

    $scope.$on('$routeChangeStart', function (event, toState, oldState) {
      if (oldState && ssrPagesWithLangPrefix.indexOf(toState.$$route.originalPath) >= 0) {
        window.location.href = toState.$$route.originalPath.replace(':location', toState.pathParams.location).replace(':slug', toState.pathParams.slug);
        event.preventDefault();
      }
      $rootScope.notFound = false;
      $rootScope.error404 = false;
      $rootScope.noIndex = false;

      $rootScope.authorized = Auth.getUser();
      $rootScope.oldState = oldState;

      if (oldState && oldState.$$route) {
        if ($rootScope.urlHistory.length < 2) {
          $rootScope.urlHistory.push(oldState.$$route.originalPath);
        } else {
          $rootScope.urlHistory = [$rootScope.urlHistory[1], oldState.$$route.originalPath];
        }
      }
      $rootScope.user = Auth.getUser();

      GTM.event('page_new_load_start');

      if (toState.data) {
        if (toState.data.authorization === false && $rootScope.authorized) {
          window.location.href = '/';
        }

        if (toState.data.authorization === true && !$rootScope.authorized) {
          $rootScope.toState = toState.$$route.originalPath;
          $location.path(utils.createURL('login')).hash('');
        }

        if (toState.data.needOrder && !$rootScope.order) {
          $location.path('/cart/');
        }
      }

      if (typeof (oldState) !== 'undefined') {
        $templateCache.remove(oldState.templateUrl);
      }
    });

    // Update sessionStorage if user changed currency
    $rootScope.$watch('currency', function (newVal, oldVal) {
      if (_.isString(newVal) && newVal !== oldVal) {
        utils.setCookie('currency_code', newVal, { path: '/' });
      }
    });


    var urlsWithoutFragment = [
      '/maldives/',
      '/addu-atoll/',
      '/laamu-atoll/',
      '/ari-atoll/',
      '/lhaviyani-atoll/',
      '/baa-atoll/',
      '/meemu-atoll/',
      '/noonu-atoll/',
      '/dhaalu-atoll/',
      '/faafu-atoll/',
      '/north-male-atoll/',
      '/raa-atoll/',
      '/fuvahmulah-atoll/',
      '/haa-alif-atoll/',
      '/south-male-atoll/',
      '/huvadhoo-atoll/',
      '/thaa-atoll/',
      '/ihavandhippolhu-atoll/',
      '/vaavu-atoll/'
    ];

    $rootScope.$on('$viewContentLoaded', function (event, currentRoute, previousRoute) {
      $rootScope.path = window.location.origin + $location.$$path;

      if (window.requireRedirect && window.requireRedirect !== selectedLanguage && utils.isBotCrawler() === false) {
        window.location.href = utils.generateLangUrl(window.requireRedirect);
      }

      $timeout(function () {
        vm.liveaboardList = _.find(vm.menu, {codeName: 'liveaboards' });
        vm.diveResortList = _.find(vm.menu, {codeName: 'dive_resorts' });
        if ($location.hash()) {
          $timeout($anchorScroll, 350);
        } else {
          $window.scrollTo(0, 0);
        }

        var hostname = window.location.origin.replace('https://', '').replace('http://', ''),
          url = $location.$$absUrl.replace('https://', '').replace('http://', ''),
          noFragment = _.find(urlsWithoutFragment,
            function (str) {
              return _.includes($location.$$path, str) && !_.includes($location.$$path, '/s/');
            }
          );

        // utils.setFragment(noFragment);
        // GTM.event(['page_new_load_finish']);

        $timeout(function () {
          GTM.variables({
            'page_data_title': $rootScope.title,
            'page_data_hostname': hostname,
            'page_data_path': $location.$$path,
          });
          // GTM.event('page_datalayer_load_finish');
        }, 2500);
      }, 300);

      if (window.ga) {
        $window.ga('send', 'pageview', {
          page: $location.url(),
        });
      }
    });

    // Change number of items in cart (header)
    $scope.$watch(function () {
      return window.localStorage.productInCart;
    }, function (newVal) {
      vm.carts = (newVal) ? JSON.parse(newVal) : [];
    });

    // This watcher I used for SEO;
    $scope.$on('leafletDirectiveMap.search-map.popupclose', function () {
      GTM.event('map_tooltip_closed');
    });

    function init() {
      var user = Auth.getUser();

      if (user) {
        Auth.setUserGTM(user);
        Account.getPreferences();
        Account.applySettings();

        if (utils.getCookie('logout') && utils.getCookie('logout') === 'True') {
          Auth.logout();
        }

        Auth.checkAffiliate().then(function (affiliate) {
          user.affiliate = affiliate;
          $rootScope.user = user;
          Auth.saveUser(user);
        }).catch(function () {
          user.affiliate = null;
          $rootScope.user = user;
          Auth.saveUser(user);
        });
      } else {
        Auth.userMeasurements();
        Auth.checkCookie();
        GTM.variables({
          user_type: 'Guest',
        });
      }

      var affiliateId = $location.search() && $location.search().aid,
        campaignId = $location.search() && $location.search().cid,
        campaignTitle = ($location.search() && $location.search().campaign_title) || 'No title';

      if ((!user || (user && !user.affiliate && !user.isStaff)) && affiliateId) {
        var curDomain = ($location.host().indexOf('padi.com') !== -1) ? 'padi.com' : $location.host(),
          gtmObject = {
            affiliate_id: affiliateId,
            affiliate_type: 'Shop affiliate',
            user_type: 'Affiliate',
          };

        utils.setCookie('padi_aid', affiliateId, { domain: curDomain, path: '/', expires: 3600 * 24 * 90 /* 90days */ });
        if (campaignId) {
          gtmObject.affiliate_campaign = campaignId + '_' + campaignTitle;
          utils.setCookie('padi_cid', campaignId, { domain: curDomain, path: '/', expires: 3600 * 24 * 90 /* 90days */ });
        }

        GTM.variables(gtmObject);

        // $location.search('aid', null)
      }

      moment.locale(window.navigator.language);

      $scope.getImage = utils.getCorrectImage;
      vm.step = 1;

      $rootScope.isMobile = utils.isMobile();
      $rootScope.user = false;
      $rootScope.urlHistory = [];

      vm.service = HomePage;
      // Need this date for footer year. (C) 2016
      vm.today = new Date();

      vm.auth = Auth;
      vm.utils = utils;
      vm.search = {};
      vm.addReview = {};
      vm.carts = cartService.getProducts();
      vm.selectedDate = localStorageService.get('date') || [];
      vm.empty = false;
      vm.contactTypes = info.contactUs;
      // Top destinations
      vm.footerTop = localStorageService.get('footerTop');


      fx.rates = false;

      if (!vm.footerTop) {
        mainInfo.getTopDestinations().then(function (data) {
          vm.footerTop = data;
          localStorageService.set('footerTop', data);
        });
      }
      // Phone number (in footer) for different user location
      vm.phoneNumber = localStorageService.get('phoneNumber');
      vm.phoneNumberToCall = localStorageService.get('phoneNumberToCall');

      if (!vm.phoneNumber || !vm.phoneNumberToCall) {
        mainInfo.getPhone().then(function (data) {
          if (data) {
            vm.phoneNumber = data[0].phone;
            vm.phoneNumberToCall = data[0].phone.replace(/ /g, '');

            console.log(vm.phoneNumberToCall);
            localStorageService.set('countryCode', data[0].countryCode);
            localStorageService.set('phoneNumber', data[0].phone);
            localStorageService.set('phoneNumberToCall', vm.phoneNumberToCall);
          }
        });
      }

      // set datepicker date
      if (vm.selectedDate) {
        vm.from = vm.selectedDate[0];
        vm.to = vm.selectedDate[1] ? vm.selectedDate[1] : '';
      }
      /* We are using rootscope for this, because we use this block on different pages,
             and for all of them we have one data.
             */
      if (!vm.destinations) {
        vm.service.getDestinations().then(function (data) {
          vm.destinations = data;
        });
      }


      if (Auth.isStaff() && $location.search() && $location.search().order_uuid) {
        localStorageService.set('order_uuid', $location.search().order_uuid);
        localStorageService.set('referrer', $location.search().referrer);

        $location.search({referrer: null});
        $location.search({order_uuid: null});

        $location.path('/checkout' + window.location.pathname);
      }

      Request.get('booking/currency/').then(function (res) {
        if (!$rootScope.currency) {
          $rootScope.currency = res.data.baseCurrency;
        }
        $rootScope.allRates = res.data.currenciesTopMenu;
        $rootScope.currencyTitles = res.data.currencyTitles;
        $rootScope.mainRates = _.keys(res.data.mainRates);
        fx.rates = _.merge(_.clone(res.data.mainRates), res.data.rates);
        fx.discount = res.data.discountPercentage;

        $rootScope.rates = fx.rates;
      });

      // Sandro analytics
      var sourceId = $location.search().source;

      if (sourceId) {
        sourceId = sourceId.split(',');
        var sourceString = '';

        _.each(sourceId, function (val) {
          sourceString += val + ',';
        });

        GTM.variables({
          user_source: sourceString.slice(0, -1),
        });
      }
    }

    function autoSuggestHome(value) {
      vm.search.q = value;

      GTM.event('search_type_query');
      if (value.length < 3) {
        return false;
      }

      return vm.service.search(vm.search);
    }

    function autoSuggest(value, noKind, kind) {
      vm.search.q = value;

      GTM.event('search_type_query');
      if (value.length < 3) {
        return false;
      }

      if (noKind) {
        delete vm.search.kind;
      }

      if (kind) {
        vm.search.kind = kind;
      }

      return vm.service.headerSearch(vm.search);
    }

    function reviewAutoSuggest(value) {
      if (value.length < 3) {
        return false;
      }

      return vm.service.reviewAutoSuggest({
        search: value,
      });
    }

    function updateData(e) {
      if (vm.search.q) {
        var value = _.clone(vm.search.q);

        $timeout(function () {
          vm.search.q.$setViewValue(value);
        }, 500);
      }
    }

    function setValue(qty, currency, onlyNumber, to, decimals, noCurrency) {
            var displayCurrency = $rootScope.currency + ' ';
            if (!qty && !_.isNumber(qty)) {
                return '';
            }

            if (!currency) {
                currency = 'USD';
            }

            if(noCurrency) {
                displayCurrency = '';
            }

            if (fx.rates) {
                var value = fx(qty).from(currency).to(to || $rootScope.currency,fx.discount);
                if (onlyNumber) {
                    return value;
                }

                if (value >= 100000 && value < 1000000) {
                    value = value / 1000;
                    return displayCurrency + $filter('number')(value, 1) + 'K';
                } else if (value >= 1000000 && value < 1000000000) {
                    value = value / 1000000;
                    return displayCurrency + $filter('number')(value, 2) + 'M';
                } else if (value >= 1000000000) {
                    value = value / 1000000000;
                    return displayCurrency + $filter('number')(value, 2) + 'Bn';
                }

                if (decimals) {
                    return displayCurrency + $filter('number')(value, 2);
                } 
                    return displayCurrency + $filter('number')(Math.round(value), 0);
                
            }
        }

    function contactUs(form) {
      if (form.$valid) {
        var data = _.clone(vm.contact);

        data.kind = data.kind[0];

        HomePage.sendContactForm(data).then(function () {
          $rootScope.showNotify(gettextCatalog.getString('Your message has been sent. Thanks!'));

          jQuery.fancybox.close();

          $timeout(function () {
            vm.contact = null;
          }, 1000);
        });
      }
    }

    function plus(type) {
      if (!vm.enquire[type]) {
        vm.enquire[type] = 0;
      }
      vm.enquire[type] += 1;
    }

    function minus(type) {
      if (!vm.enquire[type]) {
        vm.enquire[type] = 0;
      }
      if (vm.enquire[type] <= 0) {
        return vm.enquire[type] = 0;
      }
      vm.enquire[type] -= 1;
    }

    function fileUpload($file) {
      vm.addReview.images = $file;
    }

    function submitReview(form) {
      form.$submitted = true;

      if (vm.addReview.agreement) {
        if ($rootScope.user) {
          DiveOperator.addReviewWithImg(vm.addReview).then(function (res) {
            jQuery.fancybox.close();
            vm.addReview = {};
          });
        } else {
          $rootScope.review = _.clone(vm.addReview);
          jQuery.fancybox.close();
          vm.addReview = {};
          $location.path(utils.createURL('login'));
        }
      }
    }

    function setReviewValue(params) {
      vm.addReview[params.model] = params.rating;
    }

    function clearReview() {
      vm.step = 1;
      vm.addReview = {};
    }

    // save date to session storage
    function saveDate(date, notSave) {
      if (notSave && date[0]) {
        $scope.$apply(function () {
          vm.addReview.trip_end_date = moment(date[0]).format('L');
          vm.addReview.to = date[0];
          vm.toFullDate = date[1];
        });
        return false;
      }
      if (date[0] && date[1]) {
        // date[0] = moment(date[0]).format('YYYY-MM-DD');
        // date[1] = moment(date[1]).format('YYYY-MM-DD');
        $scope.$apply(function () {
          vm.from = moment(date[0]).format('L');
          vm.to = moment(date[1]).format('L');
          vm.addReview.from = date[0];
          vm.addReview.to = date[1];

          vm.fromFullDate = date[0];
          vm.toFullDate = date[1];

          if (vm.enquire) {
            vm.enquire.firstDay = moment(date[0]).format('L');
            vm.enquire.lastDay = moment(date[1]).format('L');
            vm.enquire.firstDayFullDate = date[0];
            vm.enquire.lastDayFullDate = date[1];
          }
        });

        localStorageService.set('date', date);
      } else {
        localStorageService.set('date', []);
      }
    }

    function sendEnquiry(form, GTMevent) {
      form.$submitted = true;

      if (form.$valid) {
        var kind = _.clone(vm.enquire.kind);

        vm.enquire.shop = null;
        vm.enquire.referrer = window.location.href;

        GTM.variables({
          user_refer_affiliate_id: vm.enquire.affiliateId,
        });

        vm.enquire.affiliateId = utils.getAffiliateId().aid;

        DiveOperator.bookingEnquire(vm.enquire).then(function () {
          vm.enquire = {
            finished: true,
          };

          form.$submitted = false;


          if (GTMevent) {
            GTM.event(GTMevent);
          }

          jQuery.fancybox.update();

          $timeout(function () {
            jQuery.fancybox.close();
            jQuery.fancybox.update();

            $timeout(function () {
              vm.enquire.finished = false;
            }, 1000);
          }, 3000);
        });
      }
    }

    function popupFBlogin() {
      vm.popupLoading = true;

      vm.auth.socialLogin(function () {
        $rootScope.user = Auth.getUser();

        utils.closePopup();
        vm.popupLoading = false;
      });
    }

    function smartSearch(item) {
      if (item.modelType === 'Location' || item.modelType === 'Geo-Location') {
        // alert gavnocode
        $timeout(function () {
          $('.datepicker-header-mobile').datepicker('show');
        }, 150);

        vm.searchButtonHeaderMobileText = null;
      } else if (item.modelType === 'Shop') {
        if (item.kind === 10) {
          vm.searchButtonHeaderMobileText = gettextCatalog.getString('VIEW LIVEABOARD');
        } else if (item.kind === 20) {
          vm.searchButtonHeaderMobileText = gettextCatalog.getString('VIEW RESORT');
        }
      } else if (item.modelType === 'Travel guides') {
        vm.searchButtonHeaderMobileText = gettextCatalog.getString('READ SCUBA GUIDE');
      }
    }

    function searchOnMobile() {
      if (vm.searchParams.searchQuery) {
        if (vm.searchParams.departure_date) {
          var dep_date = _.find(vm.time, {
            id: vm.searchParams.departure_date,
          });

          diviacLocalStorage.set('departure_date' , dep_date);
          diviacLocalStorage.set('date', [dep_date.from, dep_date.to]);
          diviacLocalStorage.remove('departure_date_custom');
        } else if (vm.searchParams.departure_date_custom) {
          diviacLocalStorage.set('departure_date_custom', vm.searchParams.departure_date_custom);
          diviacLocalStorage.set('date', [vm.searchParams.departure_date_custom, moment(vm.searchParams.departure_date_custom).add(30, 'd').format('YYYY-MM-DD')]);
          diviacLocalStorage.remove('departure_date');
        }

        vm.newSearch(vm.searchParams.searchQuery);
        vm.searchParams.searchQuery = undefined;
      } else {
        vm.empty = true;
      }
    }

    function startSearch() {
      if (!vm.searchParams.searchQuery) {
        vm.empty = true;
        return;
      }
      if (!vm.searchParams.departure_date && !$rootScope.notFound) {
        // code gavno
        $timeout(function () {
          $('#month-picker .selectize-input').click();
        });
        return;
      }

      vm.searchOnMobile();
    }

    function toggleAll(array, type) {
      _.each(array, function (v, k) {
        array[k] = type;
      });
    }


    function showInclusions(slug, filter, insurance, room, duration, mealsDescription, isFixedPackage) {
      Request.get('booking/resort/inclusions/' + slug + '/', filter).then(function (res) {
        vm.inclusions = res.data;
        vm.inclusions.insurance = insurance;
        vm.inclusions.room = room;
        vm.inclusions.duration = duration;
        vm.inclusions.mealsDescription = mealsDescription;
        vm.inclusions.isFixedPackage = isFixedPackage;
      });
    }
  });
